// AUTO-GENERATED by scripts/generate-editor-templates.mjs — do not edit by hand.
// Animated templates: layers carry metadata.hfAnimations (enter/exit).
export const ANIMATED_TEMPLATES: any[] = [
  {
    "id": "tpl-title-fade",
    "name": "Título Fade",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iIzEwMTgyOCIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjN2I4Y2ZmIi8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjZmZmZmZmIj5Uw610dWxvIEZhZGU8L3RleHQ+PHRleHQgeD0iMTYwIiB5PSIxMjgiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJHZW9yZ2lhLCBzZXJpZiIgZm9udC1zaXplPSIxNSIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjc1KSI+ZW50cmFkYSBlIHNhw61kYSBzdWF2ZXM8L3RleHQ+PC9zdmc+",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "layers": [
      {
        "id": "bg-0",
        "name": "Background",
        "type": "Background",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "fill": "#101828",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "txt-1",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 280,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#ffffff",
        "fontFamily": "Cormorant",
        "fontSize": 84,
        "lineHeight": 1.15,
        "text": "Meu Vídeo Incrível",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1.2,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "fade"
          },
          "exit": {
            "duration": 0.8,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      },
      {
        "id": "txt-2",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 420,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "rgba(255,255,255,0.75)",
        "fontFamily": "Cormorant",
        "fontSize": 40,
        "lineHeight": 1.15,
        "text": "subtítulo com atraso",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.5,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      }
    ]
  },
  {
    "id": "tpl-slide-duplo",
    "name": "Slide Duplo",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iIzE3MTcxNyIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjZmZiNzAzIi8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjZmZmZmZmIj5TbGlkZSBEdXBsbzwvdGV4dD48dGV4dCB4PSIxNjAiIHk9IjEyOCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjE1IiBmaWxsPSJyZ2JhKDI1NSwyNTUsMjU1LDAuNzUpIj5lc3F1ZXJkYSAmYW1wOyBkaXJlaXRhPC90ZXh0Pjwvc3ZnPg==",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "layers": [
      {
        "id": "bg-3",
        "name": "Background",
        "type": "Background",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "fill": "#171717",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "img-4",
        "name": "StaticImage",
        "type": "StaticImage",
        "left": 60,
        "top": 120,
        "width": 520,
        "height": 480,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "src": "/hyperframes/assets/pexels-photo-9246817.jpg",
        "cropX": 0,
        "cropY": 0,
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": "#ffffff",
        "strokeWidth": 8,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 0,
            "distance": 70
          },
          "exit": {
            "duration": 0.8,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 180,
            "distance": 70
          }
        }
      },
      {
        "id": "img-5",
        "name": "StaticImage",
        "type": "StaticImage",
        "left": 700,
        "top": 120,
        "width": 520,
        "height": 480,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "src": "/hyperframes/assets/pexels-ruben-reijgwart-820557011-26886396.jpg",
        "cropX": 0,
        "cropY": 0,
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": "#ffffff",
        "strokeWidth": 8,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.2,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 180,
            "distance": 70
          },
          "exit": {
            "duration": 0.8,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 0,
            "distance": 70
          }
        }
      }
    ]
  },
  {
    "id": "tpl-zoom-foto",
    "name": "Zoom Foto",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iIzBiMGIwYiIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjMmRkNGJmIi8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjZmZmZmZmIj5ab29tIEZvdG88L3RleHQ+PHRleHQgeD0iMTYwIiB5PSIxMjgiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJHZW9yZ2lhLCBzZXJpZiIgZm9udC1zaXplPSIxNSIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjc1KSI+S2VuIEJ1cm5zIGNoZWlvPC90ZXh0Pjwvc3ZnPg==",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "layers": [
      {
        "id": "bg-6",
        "name": "Background",
        "type": "Background",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "fill": "#0b0b0b",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "img-7",
        "name": "StaticImage",
        "type": "StaticImage",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "src": "/hyperframes/assets/pexels-raoul-hoekman-2164610436-39979231.jpg",
        "cropX": 0,
        "cropY": 0,
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 6,
            "delay": 0,
            "easing": "linear",
            "type": "scale",
            "startScale": 100,
            "endScale": 112
          },
          "exit": {
            "duration": 1,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      },
      {
        "id": "txt-8",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 560,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#ffffff",
        "fontFamily": "Cormorant",
        "fontSize": 64,
        "lineHeight": 1.15,
        "text": "Zoom & Movimento",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.4,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      }
    ]
  },
  {
    "id": "tpl-tres-cards",
    "name": "Três Cards",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iI2Y4ZjVmMCIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjZTA3YTVmIi8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjMjIyIj5UcsOqcyBDYXJkczwvdGV4dD48dGV4dCB4PSIxNjAiIHk9IjEyOCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjE1IiBmaWxsPSIjNzc3Ij5zdGFnZ2VyIGRlIGVudHJhZGE8L3RleHQ+PC9zdmc+",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "layers": [
      {
        "id": "bg-9",
        "name": "Background",
        "type": "Background",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "fill": "#f8f5f0",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "img-a",
        "name": "StaticImage",
        "type": "StaticImage",
        "left": 90,
        "top": 120,
        "width": 340,
        "height": 480,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "src": "/hyperframes/assets/pexels-daniqux-30223958.jpg",
        "cropX": 0,
        "cropY": 0,
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": "#ffffff",
        "strokeWidth": 8,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 90,
            "distance": 60
          }
        }
      },
      {
        "id": "img-b",
        "name": "StaticImage",
        "type": "StaticImage",
        "left": 470,
        "top": 120,
        "width": 340,
        "height": 480,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "src": "/hyperframes/assets/pexels-nahmadofficial-12130758.jpg",
        "cropX": 0,
        "cropY": 0,
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": "#ffffff",
        "strokeWidth": 8,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.2,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 90,
            "distance": 60
          }
        }
      },
      {
        "id": "img-c",
        "name": "StaticImage",
        "type": "StaticImage",
        "left": 850,
        "top": 120,
        "width": 340,
        "height": 480,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "src": "/hyperframes/assets/pexels-roselene-de-koning-791440941-20993670.jpg",
        "cropX": 0,
        "cropY": 0,
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": "#ffffff",
        "strokeWidth": 8,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.4,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 90,
            "distance": 60
          }
        }
      }
    ]
  },
  {
    "id": "tpl-citacao",
    "name": "Citação",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iI2YyZTlkYyIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjYzk5YTViIi8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjM2QyYzFlIj5DaXRhw6fDo288L3RleHQ+PHRleHQgeD0iMTYwIiB5PSIxMjgiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJHZW9yZ2lhLCBzZXJpZiIgZm9udC1zaXplPSIxNSIgZmlsbD0iIzhhNzM1OCI+c2NhbGUtaW4gZWxlZ2FudGU8L3RleHQ+PC9zdmc+",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "layers": [
      {
        "id": "bg-d",
        "name": "Background",
        "type": "Background",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "fill": "#f2e9dc",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "pth-e",
        "name": "StaticPath",
        "type": "StaticPath",
        "left": 520,
        "top": 190,
        "width": 240,
        "height": 6,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "path": [
          [
            "M",
            0,
            0
          ],
          [
            "L",
            240,
            0
          ],
          [
            "L",
            240,
            6
          ],
          [
            "L",
            0,
            6
          ],
          [
            "Z"
          ]
        ],
        "fill": "#c99a5b",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "txt-f",
        "name": "StaticText",
        "type": "StaticText",
        "left": 160,
        "top": 240,
        "width": 960,
        "height": 200,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#3d2c1e",
        "fontFamily": "Cormorant",
        "fontSize": 56,
        "lineHeight": 1.15,
        "text": "“A simplicidade é o último grau de sofisticação.”",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "scale",
            "startScale": 90,
            "endScale": 100
          },
          "exit": {
            "duration": 0.8,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      },
      {
        "id": "txt-g",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 500,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#8a7358",
        "fontFamily": "Cormorant",
        "fontSize": 36,
        "lineHeight": 1.15,
        "text": "— Leonardo da Vinci",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.6,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      }
    ]
  },
  {
    "id": "tpl-lower-third",
    "name": "Lower Third",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iIzEwMTgyMCIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjMjc2ZWYxIi8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjZmZmZmZmIj5Mb3dlciBUaGlyZDwvdGV4dD48dGV4dCB4PSIxNjAiIHk9IjEyOCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjE1IiBmaWxsPSJyZ2JhKDI1NSwyNTUsMjU1LDAuNzUpIj5ub21lICsgZnVuw6fDo288L3RleHQ+PC9zdmc+",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "layers": [
      {
        "id": "bg-h",
        "name": "Background",
        "type": "Background",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "fill": "#101820",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "img-i",
        "name": "StaticImage",
        "type": "StaticImage",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "src": "/hyperframes/assets/pexels-shaun-putter-2164458751-39834398.jpg",
        "cropX": 0,
        "cropY": 0,
        "angle": 0,
        "opacity": 0.55,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1.4,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      },
      {
        "id": "txt-j",
        "name": "StaticText",
        "type": "StaticText",
        "left": 120,
        "top": 470,
        "width": 700,
        "height": 90,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#ffffff",
        "fontFamily": "Cormorant",
        "fontSize": 64,
        "lineHeight": 1.15,
        "text": "Alex Resolve",
        "textAlign": "left",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 0.9,
            "delay": 0.3,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 90,
            "distance": 60
          },
          "exit": {
            "duration": 0.7,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 270,
            "distance": 60
          }
        }
      },
      {
        "id": "txt-k",
        "name": "StaticText",
        "type": "StaticText",
        "left": 120,
        "top": 570,
        "width": 700,
        "height": 60,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#8fb3ff",
        "fontFamily": "Cormorant",
        "fontSize": 36,
        "lineHeight": 1.15,
        "text": "Diretor de Vídeo",
        "textAlign": "left",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 0.9,
            "delay": 0.7,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      }
    ]
  },
  {
    "id": "tpl-coracao",
    "name": "Coração",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iIzRiNGI4ZiIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjZmZmZmZmIi8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjZmZmZmZmIj5Db3Jhw6fDo288L3RleHQ+PHRleHQgeD0iMTYwIiB5PSIxMjgiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJHZW9yZ2lhLCBzZXJpZiIgZm9udC1zaXplPSIxNSIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjc1KSI+Y29tIGNvcmHDp8OjbyB2ZXRvcmlhbDwvdGV4dD48L3N2Zz4=",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "layers": [
      {
        "id": "bg-l",
        "name": "Background",
        "type": "Background",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "fill": "#4b4b8f",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "pth-m",
        "name": "StaticPath",
        "type": "StaticPath",
        "left": 560,
        "top": 120,
        "width": 100,
        "height": 92,
        "scaleX": 1.6,
        "scaleY": 1.6,
        "originX": "left",
        "originY": "top",
        "path": [
          [
            "M",
            50,
            88
          ],
          [
            "C",
            20,
            64,
            4,
            44,
            4,
            28
          ],
          [
            "C",
            4,
            11,
            16,
            4,
            28,
            4
          ],
          [
            "C",
            38,
            4,
            46,
            10,
            50,
            18
          ],
          [
            "C",
            54,
            10,
            62,
            4,
            72,
            4
          ],
          [
            "C",
            84,
            4,
            96,
            11,
            96,
            28
          ],
          [
            "C",
            96,
            44,
            80,
            64,
            50,
            88
          ],
          [
            "Z"
          ]
        ],
        "fill": "#ffffff",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 0.9,
            "delay": 0,
            "easing": "back-out",
            "type": "scale",
            "startScale": 0,
            "endScale": 100
          }
        }
      },
      {
        "id": "txt-n",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 360,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#ffffff",
        "fontFamily": "Cormorant",
        "fontSize": 60,
        "lineHeight": 1.15,
        "text": "Meu template incrível",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.3,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      },
      {
        "id": "txt-o",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 450,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "rgba(255,255,255,0.85)",
        "fontFamily": "Cormorant",
        "fontSize": 40,
        "lineHeight": 1.15,
        "text": "Clique duplo para editar",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.6,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      }
    ]
  },
  {
    "id": "tpl-video-hero",
    "name": "Vídeo Hero",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iIzBkMWIyYSIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjZTYzOTQ2Ii8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjZmZmZmZmIj5Ww61kZW8gSGVybzwvdGV4dD48dGV4dCB4PSIxNjAiIHk9IjEyOCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjE1IiBmaWxsPSJyZ2JhKDI1NSwyNTUsMjU1LDAuNzUpIj52w61kZW8gZGUgZnVuZG8gKyBvdmVybGF5PC90ZXh0Pjwvc3ZnPg==",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "layers": [
      {
        "id": "bg-p",
        "name": "Background",
        "type": "Background",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "fill": "#0d1b2a",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "vid-q",
        "name": "StaticVideo",
        "type": "StaticVideo",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "src": "/hyperframes/assets/14350944-hd_1920_1080_50fps.mp4",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "pth-r",
        "name": "StaticPath",
        "type": "StaticPath",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "path": [
          [
            "M",
            0,
            0
          ],
          [
            "L",
            1280,
            0
          ],
          [
            "L",
            1280,
            720
          ],
          [
            "L",
            0,
            720
          ],
          [
            "Z"
          ]
        ],
        "fill": "rgba(0,0,0,0.45)",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "txt-s",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 260,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#ffffff",
        "fontFamily": "Cormorant",
        "fontSize": 90,
        "lineHeight": 1.15,
        "text": "A Jornada Começa",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 6,
            "delay": 0,
            "easing": "linear",
            "type": "scale",
            "startScale": 100,
            "endScale": 120
          },
          "exit": {
            "duration": 1,
            "delay": 0,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      },
      {
        "id": "txt-t",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 420,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "rgba(255,255,255,0.85)",
        "fontFamily": "Cormorant",
        "fontSize": 36,
        "lineHeight": 1.15,
        "text": "edite os textos e as animações",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.6,
            "easing": "quadratic-out",
            "type": "slide",
            "direction": 90,
            "distance": 40
          }
        }
      }
    ]
  },
  {
    "id": "tpl-final-tribute",
    "name": "Tributo Final",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iIzAwMDAwMCIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjZmZmZmZmIi8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjZmZmZmZmIj5SZXN0IGluIFBlYWNlPC90ZXh0Pjx0ZXh0IHg9IjE2MCIgeT0iMTI4IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0iR2VvcmdpYSwgc2VyaWYiIGZvbnQtc2l6ZT0iMTUiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC43NSkiPm5vc3NvIHF1ZXJpZG8gQnVkZHk8L3RleHQ+PC9zdmc+",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "layers": [
      {
        "id": "bg-u",
        "name": "Background",
        "type": "Background",
        "left": 0,
        "top": 0,
        "width": 1280,
        "height": 720,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "fill": "#000000",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {}
      },
      {
        "id": "txt-v",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 240,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#ffffff",
        "fontFamily": "Petemoss",
        "fontSize": 132,
        "lineHeight": 1.15,
        "text": "Rest in Peace",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/petemoss/v9/A2BZn5tA2xgtGWHZgykZuqc.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 6,
            "delay": 0,
            "easing": "linear",
            "type": "scale",
            "startScale": 100,
            "endScale": 115
          }
        }
      },
      {
        "id": "txt-w",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 340,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#ffffff",
        "fontFamily": "Cormorant",
        "fontSize": 56,
        "lineHeight": 1.15,
        "text": "nosso querido",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 1,
            "delay": 0.4,
            "easing": "quadratic-out",
            "type": "fade"
          }
        }
      },
      {
        "id": "txt-x",
        "name": "StaticText",
        "type": "StaticText",
        "left": 140,
        "top": 420,
        "width": 1000,
        "height": 120,
        "scaleX": 1,
        "scaleY": 1,
        "originX": "left",
        "originY": "top",
        "charSpacing": 0,
        "fill": "#ffffff",
        "fontFamily": "Petemoss",
        "fontSize": 150,
        "lineHeight": 1.15,
        "text": "Buddy",
        "textAlign": "center",
        "underline": false,
        "fontURL": "https://fonts.gstatic.com/s/petemoss/v9/A2BZn5tA2xgtGWHZgykZuqc.woff2",
        "angle": 0,
        "opacity": 1,
        "visible": true,
        "stroke": null,
        "strokeWidth": 0,
        "shadow": null,
        "flipX": false,
        "flipY": false,
        "skewX": 0,
        "skewY": 0,
        "metadata": {},
        "hfAnimations": {
          "enter": {
            "duration": 6,
            "delay": 0,
            "easing": "linear",
            "type": "scale",
            "startScale": 100,
            "endScale": 115
          }
        }
      }
    ]
  },
  {
    "id": "tpl-tribute-video",
    "name": "Tribute Video (template alvo)",
    "preview": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iIzBkMGQwZCIvPjxyZWN0IHg9IjI0IiB5PSIzMCIgd2lkdGg9IjkwIiBoZWlnaHQ9IjYiIHJ4PSIzIiBmaWxsPSIjZmZmZmZmIi8+PHRleHQgeD0iMTYwIiB5PSI5OCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Ikdlb3JnaWEsIHNlcmlmIiBmb250LXNpemU9IjI2IiBmaWxsPSIjZmZmIj5BIEpvdXJuZXkgb2Y8L3RleHQ+PHRleHQgeD0iMTYwIiB5PSIxMjgiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJHZW9yZ2lhLCBzZXJpZiIgZm9udC1zaXplPSIxNSIgZmlsbD0iI2ZmZiI+Q29tcGFuaW9uc2hpcDwvdGV4dD48L3N2Zz4=",
    "frame": {
      "width": 1280,
      "height": 720
    },
    "scenes": [
      {
        "id": "scene-13",
        "name": "Title-Scene",
        "duration": 6000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-y",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "vid-z",
            "name": "StaticVideo",
            "type": "StaticVideo",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/14350944-hd_1920_1080_50fps.mp4",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "txt-10",
            "name": "StaticText",
            "type": "StaticText",
            "left": 0,
            "top": 197.60219999999998,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Cormorant",
            "fontSize": 91.65599999999999,
            "lineHeight": 1.15,
            "text": "A Journey",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "txt-11",
            "name": "StaticText",
            "type": "StaticText",
            "left": 0,
            "top": 297.23364000000004,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Cormorant",
            "fontSize": 67.896,
            "lineHeight": 1.15,
            "text": "of",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "txt-12",
            "name": "StaticText",
            "type": "StaticText",
            "left": 0,
            "top": 322.263,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Petemoss",
            "fontSize": 173.448,
            "lineHeight": 1.15,
            "text": "Companionship",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/petemoss/v9/A2BZn5tA2xgtGWHZgykZuqc.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-16",
        "name": "Intro-Text",
        "duration": 6000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-14",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "txt-15",
            "name": "StaticText",
            "type": "StaticText",
            "left": 0,
            "top": 323.0298,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Cormorant",
            "fontSize": 64.29599999999999,
            "lineHeight": 1.15,
            "text": "in loving memory of",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-1a",
        "name": "Intro-Dedication",
        "duration": 6000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-17",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "txt-18",
            "name": "StaticText",
            "type": "StaticText",
            "left": 0,
            "top": 389.49804,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Cormorant",
            "fontSize": 64.29599999999999,
            "lineHeight": 1.15,
            "text": "12.2.2002 ~ 12.3.2024",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "txt-19",
            "name": "StaticText",
            "type": "StaticText",
            "left": 0,
            "top": 260.87004,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Cormorant",
            "fontSize": 106.776,
            "lineHeight": 1.15,
            "text": "Buddy Barker",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-1e",
        "name": "Single-Photo-With-Caption",
        "duration": 9000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-1b",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "txt-1c",
            "name": "StaticText",
            "type": "StaticText",
            "left": 128.71808,
            "top": 611.8776,
            "width": 1022.56384,
            "height": 76.79592000000001,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Cormorant",
            "fontSize": 57.6,
            "lineHeight": 1.15,
            "text": "A faithful companion and a life filled with love and joy...",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "img-1d",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 245.99040000000002,
            "top": 53.705160000000035,
            "width": 788.0192,
            "height": 527.48568,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-daniqux-30223958.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "linear",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-1r",
        "name": "Multiple-Photos-Parallax",
        "duration": 21000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-1f",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "img-1g",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-nahmadofficial-12130758.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "img-1h",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 352.99703039999986,
            "top": -144.80424,
            "width": 308.45713920000003,
            "height": 229.12848,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-photo-9246817.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          },
          {
            "id": "img-1i",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 374.5010303999999,
            "top": -144.80424,
            "width": 308.45713920000003,
            "height": 229.12848,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-raoul-hoekman-2164610436-39979231.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 1.5,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          },
          {
            "id": "img-1j",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 379.87703039999985,
            "top": -144.80424,
            "width": 308.45713920000003,
            "height": 229.12848,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-roselene-de-koning-791440941-20993670.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 1.5,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          },
          {
            "id": "img-1k",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": -141.5949696,
            "top": -144.80424,
            "width": 308.45713920000003,
            "height": 229.12848,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-ruben-reijgwart-820557011-26886396.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 1.5,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          },
          {
            "id": "img-1l",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": -125.4669696,
            "top": -144.80424,
            "width": 308.45713920000003,
            "height": 229.12848,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-shaun-putter-2164458751-39834398.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 1.5,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          },
          {
            "id": "img-1m",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 46.86912000000001,
            "top": -272.772,
            "width": 734.4217600000001,
            "height": 545.544,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-nahmadofficial-12130758.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          },
          {
            "id": "img-1n",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 123.66911999999996,
            "top": -272.772,
            "width": 734.4217600000001,
            "height": 545.544,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-daniqux-30223958.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0.5,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          },
          {
            "id": "img-1o",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 59.669119999999964,
            "top": -272.772,
            "width": 734.4217600000001,
            "height": 545.544,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-nahmadofficial-12130758.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0.5,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          },
          {
            "id": "img-1p",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 482.06911999999994,
            "top": -272.772,
            "width": 734.4217600000001,
            "height": 545.544,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-photo-9246817.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0.5,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          },
          {
            "id": "img-1q",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 443.6691200000001,
            "top": -272.772,
            "width": 734.4217600000001,
            "height": 545.544,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-raoul-hoekman-2164610436-39979231.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0.5,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              },
              "exit": {
                "duration": 1,
                "easing": "sinusoid-in-out",
                "type": "slide",
                "direction": 90,
                "distance": 50
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-1v",
        "name": "Single-Photo-With-Backdrop",
        "duration": 10000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-1s",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "img-1t",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-roselene-de-koning-791440941-20993670.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "linear",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "img-1u",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 434.99391999999995,
            "top": 92.86739999999998,
            "width": 373.85216,
            "height": 534.2652,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-roselene-de-koning-791440941-20993670.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "linear",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-20",
        "name": "Three-Photos",
        "duration": 10000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-1w",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "img-1x",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 74.72576000000004,
            "top": 92.86739999999998,
            "width": 339.94879999999995,
            "height": 534.2652,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-ruben-reijgwart-820557011-26886396.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "img-1y",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 470.02560000000005,
            "top": 92.86739999999998,
            "width": 339.94879999999995,
            "height": 534.2652,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-shaun-putter-2164458751-39834398.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "img-1z",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 865.32544,
            "top": 92.86739999999998,
            "width": 339.94879999999995,
            "height": 534.2652,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-daniqux-30223958.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-25",
        "name": "Two-Photos",
        "duration": 10000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-21",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#333333",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "img-22",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-nahmadofficial-12130758.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "img-23",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 122.48768000000004,
            "top": -7.968959999999981,
            "width": 478.8416,
            "height": 735.93792,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-nahmadofficial-12130758.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "linear",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "img-24",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 678.67072,
            "top": -7.968959999999981,
            "width": 478.8416,
            "height": 735.93792,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-photo-9246817.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "linear",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-28",
        "name": "Single-Photo-Fullscreen",
        "duration": 10000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-26",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "img-27",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-raoul-hoekman-2164610436-39979231.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "linear",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-2c",
        "name": "Single-Photo-With-Angle",
        "duration": 10000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-29",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "img-2a",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-roselene-de-koning-791440941-20993670.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "linear",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "img-2b",
            "name": "StaticImage",
            "type": "StaticImage",
            "left": 117.00671999999997,
            "top": 171.37872,
            "width": 660.62208,
            "height": 374.73983999999996,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/pexels-roselene-de-koning-791440941-20993670.jpg",
            "cropX": 0,
            "cropY": 0,
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": "#ffffff",
            "strokeWidth": 10.799999999999999,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "linear",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-2g",
        "name": "Farewell-Message",
        "duration": 9000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-2d",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "vid-2e",
            "name": "StaticVideo",
            "type": "StaticVideo",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "src": "/hyperframes/assets/14350944-hd_1920_1080_50fps.mp4",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "txt-2f",
            "name": "StaticText",
            "type": "StaticText",
            "left": 174.54399999999993,
            "top": 307.008,
            "width": 930.9120000000001,
            "height": 250.05024,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Cormorant",
            "fontSize": 92.16,
            "lineHeight": 1.15,
            "text": "As we look to the stars, we see not just their light, but the warmth of our beloved pet's spirit, watching over us and reminding us of the love we shared.",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      },
      {
        "id": "scene-2l",
        "name": "Final-Tribute",
        "duration": 6000,
        "frame": {
          "width": 1280,
          "height": 720
        },
        "layers": [
          {
            "id": "bg-2h",
            "name": "Background",
            "type": "Background",
            "left": 0,
            "top": 0,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "fill": "#000000",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {}
          },
          {
            "id": "txt-2i",
            "name": "StaticText",
            "type": "StaticText",
            "left": 0,
            "top": 186.49692000000005,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Petemoss",
            "fontSize": 131.976,
            "lineHeight": 1.15,
            "text": "Rest in Peace",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/petemoss/v9/A2BZn5tA2xgtGWHZgykZuqc.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "txt-2j",
            "name": "StaticText",
            "type": "StaticText",
            "left": 0,
            "top": 298.68732000000006,
            "width": 1280,
            "height": 720,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Cormorant",
            "fontSize": 56.376,
            "lineHeight": 1.15,
            "text": "our dear",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/cormorant/v24/H4clBXOCl9bbnla_nHIq75u9.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          },
          {
            "id": "txt-2k",
            "name": "StaticText",
            "type": "StaticText",
            "left": 237.64607999999998,
            "top": 406.04976,
            "width": 804.70784,
            "height": 219.43872,
            "scaleX": 1,
            "scaleY": 1,
            "originX": "left",
            "originY": "top",
            "charSpacing": 0,
            "fill": "#ffffff",
            "fontFamily": "Petemoss",
            "fontSize": 57.6,
            "lineHeight": 1.15,
            "text": "Buddy",
            "textAlign": "center",
            "underline": false,
            "fontURL": "https://fonts.gstatic.com/s/petemoss/v9/A2BZn5tA2xgtGWHZgykZuqc.woff2",
            "angle": 0,
            "opacity": 1,
            "visible": true,
            "stroke": null,
            "strokeWidth": 0,
            "shadow": null,
            "flipX": false,
            "flipY": false,
            "skewX": 0,
            "skewY": 0,
            "metadata": {},
            "hfAnimations": {
              "enter": {
                "duration": 1,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "scale",
                "startScale": 100,
                "endScale": 120
              },
              "exit": {
                "duration": 2,
                "delay": 0,
                "easing": "quadratic-out",
                "type": "fade"
              }
            }
          }
        ],
        "metadata": {}
      }
    ]
  }
]
